import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const FounderPage = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Our Founder"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Our Founder" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />


         <section class="space-ptb">
          <div class="container">
            <div class="row align-items-start">
              <div className='col-md-12'>
                  <h2 class="title mb-3 text-start"><span class="text-primary">हृदयोद्गार</span></h2>
                  
              </div>
              <div class="col-md-8">
                <div class="mb-4 pr-lg-5">         
                    <p>
                      जो आपने जलाई थी ज्ञान की मशाल। जलती रहे सदा वो अविरल असंख्य साल।।
                      अपनी न थी इमारत, संख्या भी बहुत कम थी,थी आय अल्प लेकिन उत्साह की चरम थी 
                      अधिकार कर्म केवल फल का नहीं मलाल, जलती रहे. 
                    </p>
                    <p>
                      सेवा में रहे जब तक उत्साह से पढ़ाया, पुस्तक लिखी गणित की और ज्ञान निधि बढ़ाया, 
                      शिक्षा के क्षेत्र में है किया आपने कमाल, जलती रहे.
                    </p>
                    <p>
                      हैं आप कर्म योगी गीता से मिली शिक्षा, आगे कदम बढ़े हैं, मिलती है उच्च शिक्षा,
                      शिक्षा के क्षेत्र में हैं सर आप बेमिसाल, जलती रहे.
                    </p>
                    <p>
                      लहराया दो जिलों में है ज्ञान का जो परचम, 19 शाखाओं के रूप में बढ़ रहे हैं कदम,
                      शिक्षा प्रसार का है कितना रखा ख्याल,जलती रहे.
                    </p>
                    <p>
                      उत्पाद पायनियर के हैं बन चुके वैज्ञानिक, इंजीनियर, चिकित्सक कितने ही श्रेष्ठ कार्मिक,
                      करते हैं देश सेवा रखा मचा धमाल,जलती रहे.
                    </p>
                    <p>
                      इच्छा प्रकाश इसकी, श्री वृद्धि होती जाए, स्वर्णाक्षरों में इसका नित नाम जगमगाए,
                      प्रतिद्वन्दिता करे जो किसकी है ये मजाल। जलती रहे सदा वो अविरल असंख्य साल।
                    </p>
                   <p>अंत में अपने सभी छात्र/छात्राओं को उनके उज्जवल भविष्य की कामनाओं सहित : आपका ही</p>

                    <p className='pt-2 fw-bold pb-0 mb-0'>पूरन सिंह</p>
                    <p>संस्थापक प्रबंधक</p>
                </div>            
              </div> 
              <div class="col-md-4">
                  <img src="images/team/founder-new.png" className='w-100' alt='' style={{objectFit:'cover'}} />
              </div>         
            </div>
          </div>
      </section>
    </>
  )
}

export default FounderPage
